import { biToast } from '@pulsepointinc/bi-components';
import { useQuery } from '@tanstack/react-query';
import { fetchPermissions, type PermissionsDataRequest, type PermissionsResponse } from '../../lib/api/permission';

export function usePermissionsQuery(
  params: PermissionsDataRequest,
  options?: { enabled?: boolean; staleTime?: number },
) {
  return useQuery<PermissionsResponse>({
    queryKey: ['permissions', params],
    queryFn: () => fetchPermissions(params),
    meta: {
      onError: () => {
        biToast.error('Failed to Load', 'Unable to load permissions. Please refresh the page.');
      },
    },
    enabled: options?.enabled ?? true,
    ...(options?.staleTime ? { staleTime: options.staleTime } : {}),
  });
}
